/* eslint-disable no-restricted-globals */
import { register } from 'register-service-worker'
import { NewVersionLabel } from './constants'

const serviceWorkerUrl = `${process.env.PUBLIC_URL}/service-worker.js`
const UPDATE_CHECK_INTERVAL_MS = 15 * 60 * 1000

/** Le navigateur ne vérifie le service worker qu'à la navigation : on force la vérification
 * périodiquement et au retour sur l'onglet pour afficher la bannière sans recharger la page.
 */
function watchForUpdates(registration: ServiceWorkerRegistration) {
  const checkForUpdate = () => {
    registration
      .update()
      .catch((error) => console.warn('Service worker : Vérification impossible', error))
  }
  setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL_MS)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkForUpdate()
    }
  })
}

export function registerServiceWorker() {
  register(serviceWorkerUrl, {
    registered(registration) {
      console.info('Service worker : Prêt')
      watchForUpdates(registration)
    },
    updated(registration) {
      console.info('Service worker : Une nouvelle version est prête')
      document.dispatchEvent(new CustomEvent(NewVersionLabel, { detail: registration }))
    },
    updatefound() {
      console.info('Service worker: Mise à jour en cours')
    },
    cached() {
      console.info('Service worker : Version mise en cache')
    },
    error(error) {
      console.error(`Service worker :`, error)
    },
  })
}
